import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LandingPageService } from '../landing-page.service';

@Component({
  selector: 'app-massive-import-view',
  templateUrl: './massive-import-view.component.html',
  styleUrls: ['./massive-import-view.component.scss'],
})
export class MassiveImportViewComponent implements OnInit {

  @Input() documentId: number;
  public massiveDetail: any;
  public detailsArray: any;
  public dataSource: any;
  public page: number = 1;
  public wait = true;
  private ignoredIds: number[] = [];
  pageEvent: PageEvent;
  public displayedColumns: string[] = [
    // 'id',
    // 'olo',
    // 'service',
    'b_end',
    'b_end_coordinates',
    'b_end_afference_pop',
    'a_end_1',
    'a_end_2',
    // 'cluster',
    // 'total_cost_commercial',
    // 'total_elapsed',
    // 'total_distance',
    // 'feasibility_check',
    'actions'
  ];

  constructor(private landingService: LandingPageService) { }

  ngOnInit(): void {
    this.getMassiveDetail(this.documentId, this.page);
    this.ignoredIds = [];
  }

  getMassiveDetail(id, page) {
    this.landingService.getMassiveDetail(id, page).subscribe(res => {
      this.massiveDetail = res;
      this.detailsArray = res.results;
      this.dataSource = new MatTableDataSource(this.detailsArray);
      this.wait = false
    }, err => {
      this.wait = false
    });
  }

  setPage(event) {
    this.page = event.pageIndex + 1;
    this.getMassiveDetail(this.documentId, this.page);
  }

  removeId(id) {
    const index = this.ignoredIds.indexOf(id);
    if (index > -1) {
      this.ignoredIds.splice(index, 1);
    } else {
      this.ignoredIds.push(id);
    }
  }

  sendToSalesforce() {
    const req = {
      document_id: this.documentId,
      ignored_p2p_ids: this.ignoredIds
    };
    this.landingService.sendToSalesforce(req).subscribe(res => {
      window.location.href = res.url;
    }, err => {
      console.log(err);
    });
  }


}
